module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA6CAYAAADybArcAAAABGdBTUEAALGPC/xhBQAAALtJREFUaAXtksENgCAAxMQJ3H9KN8C4QrHGmPrvCS3b9pNv3PeYc54r9xljHCv8E//fVw7wJbaLfKnGfZaKVEQy0NOSxOLZimB1ElgRSSyerQhWJ4EVkcTi2YpgdRJYEUksnq0IVieBFZHE4tmKYHUSWBFJLJ6tCFYngRWRxOLZimB1ElgRSSyerQhWJ4EVkcTi2YpgdRJYEUksnq0IVieBFZHE4tmKYHUSWBFJLJ6tCFYngb8pIvl5f/YCAuMIcFqvJvcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/components/video/assets/pause-icon.png
// module id = 231
// module chunks = 1 2 3 4 5 7 8 9 10 13 18 19 20 22 25 31 70 73 74